<template>
  <div class="head-navbar">
    <!-- <hamburger
      class="hamburger-container"
      :toggleClick="toggleSideBar"
      :isActive="sidebar.opened"
    ></hamburger> -->
    <div class="navbar-breadcrumb">
      <breadcrumb></breadcrumb>
    </div>

    <!-- <el-input
      v-model="funcKeyword"
      size="small"
      class="nav-input"
      placeholder="请输入功能名称"
    >
      <el-image
        slot="suffix"
        class="nav-input-icon"
        src="https://cdn-hz.renrenjiang.cn/teacher_center/website/icon_table_search.png"
      ></el-image>
    </el-input> -->
    <el-select
      v-if="$route.path.indexOf('/p/') === -1"
      class="nav-input"
      v-model="funcKeyword"
      filterable
      remote
      reserve-keyword
      placeholder="请输入功能名称"
      :remote-method="remoteMethod"
      :loading="loading"
      size="small"
      @change="routesChange"
      clearable
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>

    <!-- <el-cascader
      :options="routes"
      filterable
      :props="{ value: 'path' }"
      placeholder="试试搜索：学员"
      size="small"
      :filter-method="filterMethod"
      @change="routesChange"
    >
      <template slot-scope="{ data }">
        <span>{{ data.meta.title }}</span>
      </template>
    </el-cascader> -->

    <div v-if="$route.path.indexOf('/p/') === -1" class="navbar-menus">
      <!-- <div class="menu-item">
        <div @click="openDrawer" class="menu-item-text">帮助弹框</div>
      </div> -->
      <!-- <template
        v-if="(user && user.id === 21217432) || hybrid_douyin_chat === '1'"
      >
        <div class="menu-item">
          <div @click="openIM" class="menu-item-text">社群</div>
        </div>
        <div class="head-divider"></div>
      </template> -->

      <div @click="showDrawer" class="menu-item">
        <el-badge :value="messageCount.all" :hidden="messageCount.all === 0">
          <div class="menu-item-text">通知</div>
        </el-badge>
      </div>
      <div class="head-divider"></div>
      <div @click="teacherHomeDialog.visible = true" class="menu-item">
        <div class="menu-item-text">讲师主页</div>
      </div>
      <!-- <div class="head-divider"></div> -->
      <div class="menu-item">
        <el-button type="primary" size="small" @click="openHelpCenter">
          返回旧版讲师中心
          <i class="el-icon-arrow-right el-icon--right"></i>
        </el-button>
      </div>
    </div>
    <div v-else class="navbar-menus">
      <div @click="openPlanet" class="menu-item">
        <div class="menu-item-text">前往星球主页</div>
      </div>
    </div>

    <div class="avatar-container">
      <el-popover v-if="user" placement="bottom-end" trigger="hover">
        <div class="avatar-wrapper" slot="reference">
          <el-avatar
            class="user-avatar"
            :src="user.avatar + '?imageView2/1/w/80/h/80'"
          ></el-avatar>
          <div class="user-info">
            <div class="user-info-name">{{ user.nickname }}</div>
            <div class="user-info-uid">ID：{{ user.uid }}</div>
          </div>
          <el-image
            class="user-arrow"
            src="https://image.renrenjiang.cn/teacher_center/douyin/icon_navbar_arrow.png"
          ></el-image>
        </div>
        <div class="user-menu-block">
          <div class="menu-user">
            <el-image
              class="user-avatar"
              fit="cover"
              :src="user.avatar"
            ></el-image>
            <div class="user-nickname">{{ user.nickname }}</div>
          </div>
          <div class="menu-divider"></div>
          <div class="user-menu-list">
            <div class="menu-item">
              <div class="menu-item-icon account-setting"></div>
              <div class="menu-item-text">账号设置</div>
            </div>
            <div class="menu-item" @click="logout">
              <div class="menu-item-icon account-logout"></div>
              <div class="menu-item-text">退出账号</div>
            </div>
          </div>
        </div>
      </el-popover>
    </div>

    <el-drawer
      :visible.sync="noticeDrawer.visible"
      :show-close="false"
      direction="rtl"
      append-to-body
      size="672px"
    >
      <div class="notice-block">
        <div class="notice-title-block">
          <div class="title-block-text">通知中心</div>
          <div class="title-block-close" @click="closeDrawer"></div>
        </div>
        <div class="notice-title-filter">
          <div class="notice-title-tabs">
            <div
              v-for="(tab, index) in tabs"
              :key="tab.type"
              class="tab-item"
              :class="{ active: tabIndex === index }"
              @click="changeTab(index)"
            >
              <el-badge
                :value="messageCount[tab.type]"
                :hidden="messageCount[tab.type] === 0"
              >
                <div class="tab-item-text">{{ tab.title }}</div>
              </el-badge>
            </div>
          </div>
          <div class="notice-title-btn" @click="setreadAll">
            <div class="read-icon"></div>
            全部标为已读
          </div>
        </div>
        <div class="read-filter">
          <div
            v-for="(read, index) in reads"
            :key="read.title"
            class="read-filter-item"
            :class="{ active: readIndex === index }"
            @click="changeRead(index)"
          >
            {{ read.title }}
          </div>
        </div>
        <div class="notice-list">
          <div v-for="i in list" class="notice-item" :key="i">
            <div class="notice-item-title">
              <el-badge is-dot>
                <span class="title-text">商品信息发布规则解读，避免违规</span>
              </el-badge>
            </div>
            <div class="notice-item-content">
              商品的信息要如何写才能避免违规？这里为你整理了全面的规则解读，10分钟帮你避免违规受罚风险，点击立即学习
            </div>
            <div class="notice-item-info">
              <div class="notice-item-type">
                <span class="type-text">平台动态</span>
                <span class="type-time">22分钟前</span>
              </div>
              <div @click="readMessage(i.id)" class="notice-item-btn">
                立即查看
              </div>
            </div>
          </div>
          <empty v-if="list.length === 0" text="暂无数据"></empty>
        </div>
      </div>
    </el-drawer>

    <el-dialog
      :show-close="false"
      :visible.sync="teacherHomeDialog.visible"
      width="300px"
      append-to-body
    >
      <div class="dialog-head">
        <div class="dialog-head-title">讲师主页</div>
        <div
          @click="teacherHomeDialog.visible = false"
          class="dialog-head-close"
        ></div>
      </div>
      <div class="dialog-body padding">
        <div class="teacher-home-block">
          <el-image
            v-if="user"
            class="teacher-home-qrcode"
            :src="
              'https://api.renrenjiang.cn/api/v3/tt/qrcode?path=pages/teacher/index?teacherId=' +
              user.id
            "
          ></el-image>
          <div class="teacher-home-title">打开抖音扫一扫</div>
          <div class="teacher-home-tips">访问知识付费店铺主页</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Empty from "@/views/layout/empty";

import { removeToken, removeRefreshToken } from "@/utils/auth";

import {
  messageSetreadAll,
  messageSetread,
  getMessageList,
  getUnReadMessageCount,
} from "@/api/message";
import { findWebappAuth } from "@/api/im";
import { getSwitch } from "@/api/user";
// import Hamburger from "@/components/Hamburger";
// import UserSearch from "@/components/UserSearch";
// import { getToken } from "@/utils/auth";

export default {
  components: {
    Breadcrumb,
    Empty,
    // Hamburger,
    // UserSearch,
  },
  data() {
    return {
      funcKeyword: "",
      // user: null,
      noticeDrawer: { visible: false },
      messageCount: {
        all: 0,
        deal: 0,
        market: 0,
        official: 0,
        platform: 0,
      },
      query: {
        page: 1,
        pageSize: 10,
        msgType: "platform",
        status: 0,
      },
      list: [],
      teacherHomeDialog: {
        visible: false,
      },
      tabs: [
        {
          type: "platform",
          title: "平台",
        },
        {
          type: "deal",
          title: "交易",
        },
        {
          type: "market",
          title: "营销",
        },
        {
          type: "official",
          title: "官方",
        },
      ],
      tabIndex: 0,
      reads: [
        {
          title: "全部消息",
        },
        {
          status: 0,
          title: "仅显示未读",
        },
        {
          status: 1,
          title: "仅显示已读",
        },
      ],
      readIndex: 1,
      options: [],
      loading: false,
      hybrid_douyin_chat: 0,
    };
  },
  computed: {
    ...mapGetters(["sidebar", "user", "avatar", "permission_routers"]),
    routes() {
      let result = [];
      // 处理出来数据
      this.permission_routers.forEach((route) => {
        Array.isArray(route.children) &&
          route.children.forEach((child) => {
            if (!child.hidden) {
              const label =
                child.meta.title === "首页"
                  ? "首页"
                  : route.meta.title + "/" + child.meta.title;
              result.push({
                label: label,
                value: child.path,
              });
            }
          });
      });
      return result;
    },
  },
  created() {
    this.getNumber();
    this.getList();
    this.loadSwitch();
  },
  methods: {
    async loadSwitch() {
      let res = await getSwitch({
        user_id: this.user.id,
        include: "hybrid_douyin_chat",
      });
      console.log("switch", res);
      this.hybrid_douyin_chat = res.hybrid_douyin_chat;
    },
    openDrawer() {
      this.$store.dispatch("TOGGLEDRAWER").then(() => {});
    },
    openHelpCenter() {
      // let routeUrl = this.$router.resolve({
      //   path: "/helps",
      // });
      const token = this.$rrj.storage.get("_token");
      const url = `https://teacher.renrenjiang.cn/#/activities?access_token=${token.id}`;
      window.open(url, "_blank");
    },
    openPlanet() {
      const token = this.$rrj.storage.get("_token");
      const url = `https://www.xingqiuhuiyuan.com/#/index?access_token=${token.id}`;
      window.open(url, "_blank");
    },
    async openIM() {
      let res = await findWebappAuth();
      if (res.data && res.data.data && res.data.data.access_token) {
        let routeUrl = this.$router.resolve({
          path: "/customer/chat",
        });
        window.open(routeUrl.href, "_blank");
      } else {
        let scopes = [
          "item.comment",
          "user_info",
          // "trial.whitelist",
          "fans.check",
          "im.direct_message",
          "im.group_message",
          "im.recall_message",
          "im.message_card",
          "im.microapp_card",
          "tool.image.upload",
          "video.list.bind",
          "video.data.bind",
          "data.external.item",
          "data.external.user",
          "fans.data.bind",
          "data.external.fans_source",
          "data.external.fans_favourite",
        ];
        this.$confirm("已完成账号授权？", "提示", {
          confirmButtonText: "授权完成",
          cancelButtonText: "授权失败",
          type: "warning",
        })
          .then(() => {
            this.openIM();
          })
          .catch(() => {});
        let authurl =
          "https://open.douyin.com/platform/oauth/connect/?response_type=code&client_key=awyu19tt8gwsp2gg&scope=" +
          scopes.join(",") +
          "&state=10001&redirect_uri=https://dy.renrenjiang.cn";
        window.open(authurl, "_blank");
      }
    },
    showDrawer() {
      this.noticeDrawer.visible = !this.noticeDrawer.visible;
      this.query.page = 1;
      this.$nextTick(() => {
        const el = document.querySelector(".notice-list");
        const offsetHeight = el.offsetHeight;
        el.onscroll = () => {
          const scrollHeight = el.scrollHeight;
          const scrollTop = el.scrollTop;
          const num = offsetHeight + scrollTop - scrollHeight;
          console.log("scroll", num);
          if (num > -15) {
            this.query.page += 1;
            this.getList();
          }
        };
      });
    },
    // events
    // toActSearch() {
    //   this.$router.push({ name: "Browsing" });
    // },
    // toSqyAdm() {
    //   const token = getToken();
    //   const sqyUrl = `https://asqy.renrenjiang.cn/#/login?access_token=${token}`;
    //   window.open(sqyUrl);
    // },
    // toggleSideBar() {
    //   this.$store.dispatch("ToggleSideBar");
    // },
    logout() {
      console.log(this.$router);
      console.log(this.$route);
      if (this.$route.path.indexOf("/p/") !== -1) {
        this.$rrj.storage.clear();
        removeToken();
        removeRefreshToken();
        window.open("https://dy.renrenjiang.cn/#/login?p=1", "_self");
      } else {
        this.$store.dispatch("LogOut").then(() => {
          location.reload(); // 为了重新实例化vue-router对象 避免bug
        });
      }
    },
    async getNumber() {
      const res = await getUnReadMessageCount();
      if (res.result === "ok") {
        this.messageCount = res.data;
      }
    },
    async getList() {
      const res = await getMessageList(this.query);
      if (this.query.page === 1) {
        this.list = [];
      }
      this.list = [...this.list, ...res.rows];
      console.log(res);
    },
    async setreadAll() {
      const res = await messageSetreadAll();
      console.log(res);

      this.messageCount = {
        all: 0,
        deal: 0,
        market: 0,
        official: 0,
        platform: 0,
      };
      this.query.page = 1;
      this.getList();
    },
    async readMessage(messageId) {
      const res = await messageSetread({ messageId });
      console.log(res);
    },
    changeTab(idx) {
      if (this.tabIndex === idx) return;
      this.tabIndex = idx;

      this.query.msgType = this.tabs[idx].type;
      this.query.page = 1;
      this.getList();
    },
    changeRead(idx) {
      if (this.readIndex === idx) return;
      this.readIndex = idx;

      if (idx === 0) {
        delete this.query.readStatus;
      } else {
        this.query.readStatus = this.reads[idx].status;
      }

      this.query.page = 1;
      this.getList();
    },
    closeDrawer() {
      this.noticeDrawer.visible = false;
    },
    routesChange(value) {
      this.$router.push(value);
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.options = this.routes.filter((item) => {
            return item.label.indexOf(query) > -1;
          });
          this.loading = false;
        }, 100);
      } else {
        this.options = [];
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.head-navbar {
  height: 70px;
  display: flex;
  align-items: center;

  .navbar-breadcrumb {
    width: 0;
    height: 70px;
    flex-grow: 1;
  }

  .navbar-menus {
    display: inline-flex;
    align-items: center;
    margin-left: 20px;

    .head-divider {
      width: 1px;
      height: 10px;
      margin: 0 10px;
      background-color: #d6d6d6;
    }

    .menu-item {
      display: inline-flex;
      align-items: center;
      padding: 0 10px;

      .menu-item-icon {
        width: 18px;
        height: 18px;
        margin-right: 5px;
      }

      .menu-item-text {
        font-size: 14px;
        color: #686767;
        cursor: pointer;

        &:hover {
          color: #0366ff;
        }
      }
    }
  }

  .search-container {
    position: absolute;
    right: 110px;
    top: 0;
  }

  .avatar-container {
    margin-left: 20px;
    display: inline-block;

    .avatar-wrapper {
      cursor: pointer;
      position: relative;

      display: inline-flex;
      align-items: center;

      .user-avatar {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background-color: #f7f7f7;
      }

      .user-info {
        margin-left: 10px;

        .user-info-name {
          line-height: 14px;
          font-size: 14px;
        }

        .user-info-uid {
          margin-top: 6px;
          line-height: 12px;
          font-size: 12px;
          color: #686767;
        }
      }

      .user-arrow {
        width: 20px;
        height: 20px;
        margin-left: 5px;
      }
    }
  }
}

// .user-activity {
//   color: inherit;
//   position: absolute;
//   right: 220px;
//   top: 0;
//   &:focus {
//     text-decoration: none;
//   }
//   &:hover {
//     text-decoration: underline;
//   }
// }
// .user-sqy {
//   color: inherit;
//   position: absolute;
//   right: 330px;
//   top: 0;
//   &:focus {
//     text-decoration: none;
//   }
//   &:hover {
//     text-decoration: underline;
//   }
// }

.user-menu-block {
  width: 172px;

  .menu-user {
    padding: 15px;
    box-sizing: border-box;

    display: flex;
    align-items: center;

    .user-avatar {
      width: 24px;
      height: 24px;
      border-radius: 50%;
    }

    .user-nickname {
      width: 0;
      height: 20px;
      flex-grow: 1;
      margin-left: 10px;

      line-height: 20px;
      font-size: 12px;
      color: #090909;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .menu-divider {
    width: 142px;
    height: 1px;
    margin: 0 auto;
    background-color: #f7f8fa;
  }

  .user-menu-list {
    padding: 10px 0;

    .menu-item {
      width: 100%;
      height: 40px;
      padding: 0 15px;
      margin-bottom: 10px;
      box-sizing: border-box;

      display: flex;
      align-items: center;
      cursor: pointer;

      &:hover {
        background-color: #f0f6ff;

        .menu-item-icon {
          background-position: 20px 0;
        }

        .menu-item-text {
          color: #0366ff;
        }
      }

      .menu-item-icon {
        width: 20px;
        height: 20px;
        background-size: 40px 20px;
        background-position: 0 0;

        &.account-setting {
          background-image: url(https://cdn-hz.renrenjiang.cn/teacher_center/website/icon_headuser_setting_ico_tt.png);
        }

        &.account-logout {
          background-image: url(https://cdn-hz.renrenjiang.cn/teacher_center/website/icon_headuser_logout_ico_tt.png);
        }
      }

      .menu-item-text {
        margin-left: 6px;
        line-height: 20px;
        font-size: 14px;
        color: #686767;
      }
    }
  }
}

.nav-input {
  width: 175px;
}

.nav-input-icon {
  width: 32px;
  height: 32px;
  padding: 4px;
  box-sizing: border-box;
  opacity: 0.8;
}

.notice-block {
  width: 100%;
  height: 100%;
  background-color: #fafbfc;

  display: flex;
  flex-direction: column;

  .notice-title-block {
    width: 100%;
    height: 55px;
    padding: 0 24px;
    box-sizing: border-box;
    border-bottom: 1px solid #f8f8f8;

    display: flex;
    align-items: center;
    justify-content: space-between;

    .title-block-text {
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
    }

    .title-block-close {
      width: 20px;
      height: 20px;
      background-image: url(https://image.renrenjiang.cn/teacher_center/website/icon_normal_close_tt.png);
      background-size: 40px auto;
      background-position: 0 0;
      cursor: pointer;

      &:hover {
        background-position: -20px 0;
      }
    }
  }

  .read-filter {
    padding: 12px;
    box-sizing: border-box;

    display: flex;
    align-items: center;

    .read-filter-item {
      margin: 0 6px;
      padding: 6px 12px;
      border-radius: 4px;

      line-height: 20px;
      font-size: 12px;
      color: #686767;
      cursor: pointer;

      &.active {
        background-color: #ebf3ff;
        color: #0366ff;
      }
    }
  }

  .notice-title-filter {
    padding: 0 12px;
    box-sizing: border-box;

    display: flex;
    align-items: center;
    justify-content: space-between;

    .notice-title-tabs {
      height: 48px;
      display: flex;
      align-items: center;

      .tab-item {
        position: relative;
        padding: 10px 12px;
        line-height: 20px;
        cursor: pointer;
        color: #686767;

        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 50%;
          width: 0;
          height: 3px;
          border-radius: 2px;
          background-color: #0366ff;
          transition: all 0.3s;
        }

        .tab-item-text {
          padding: 0 6px;
          font-size: 14px;
        }

        &.active {
          font-weight: 500;
          color: #0366ff;

          &::after {
            left: 12px;
            width: calc(100% - 24px);
          }
        }

        &:hover {
          color: #0366ff;
        }
      }
    }
  }

  .notice-title-btn {
    margin-right: 12px;
    line-height: 20px;
    font-size: 14px;
    cursor: pointer;
    color: #686767;

    display: inline-flex;
    align-items: center;

    .read-icon {
      width: 20px;
      height: 20px;
      margin-right: 4px;
      transform: scale(0.9);

      background-image: url(https://image.renrenjiang.cn/teacher_center/douyin/icon_notice_setread.png);
      background-repeat: no-repeat;
      background-size: 40px 20px;
      background-position: 0 0;
    }

    &:hover {
      color: #0366ff;

      .read-icon {
        background-position: -20px 0;
      }
    }
  }

  .notice-list {
    width: 100%;
    height: 0;
    flex-grow: 1;
    overflow: auto;
    margin-bottom: 8px;

    padding: 0 24px;
    box-sizing: border-box;

    .notice-item {
      background-color: #ffffff;
      border-radius: 16px;
      cursor: pointer;
      margin-bottom: 8px;
      padding: 16px;
      position: relative;

      .notice-item-title {
        align-items: center;
        color: #090909;
        display: flex;
        font-size: 16px;
        font-weight: 500;
        justify-content: flex-start;
        line-height: 20px;
        padding-bottom: 10px;

        .title-text {
          padding-right: 6px;
        }
      }

      .notice-item-content {
        color: #686767;
        font-size: 14px;
        line-height: 18px;
        max-height: 36px;
        overflow: hidden;
        position: relative;
      }

      .notice-item-info {
        align-items: center;
        display: flex;
        justify-content: space-between;
        margin-top: 12px;

        .notice-item-type {
          font-size: 12px;

          .type-text {
            margin-right: 12px;
          }
        }

        .notice-item-btn {
          font-size: 12px;
          color: #0366ff;
          cursor: pointer;

          &:hover {
            opacity: 0.8;
          }
        }
      }
    }
  }
}

.teacher-home-block {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 20px;

  .teacher-home-qrcode {
    width: 150px;
    height: 150px;
  }

  .teacher-home-title {
    color: #090909;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    margin-top: 16px;
  }

  .teacher-home-tips {
    color: #acacac;
    font-size: 12px;
    line-height: 16px;
    margin-top: 6px;
  }
}
</style>
